/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Upload a profile photo as base64 JPEG.
 */
export interface PeopleProfilePhotoUploadRequest {
  /** @minLength 1 */
  imageBase64: string;
}
